import { AxiosResponse } from "axios";
import axiosConfig from "../../../../../config/axiosConfig";

const CM0061Api = () => {
  return {};
};

export default CM0061Api;
